export default function FormatIntkeDate({ date }) {
    const formatDate = (datetime) => {
      const dateObj = new Date(datetime);
      const options = { year: "numeric", month: "short" };
      return dateObj.toLocaleDateString(undefined, options);
    };
  
    return <>{formatDate(date)}</>;
  }
  